export function permissionsCanDoAction(action) {
  const actions = window.restricted_actions;
  return !actions.includes(action);
}

export function permissionsCanAccessFeature(feature) {
  if (!permissionsCustomerCanAccessFeature(feature)) {
    return false;
  }
  const features = window.restricted_features;
  return !features.includes(feature);
}

export function permissionsCustomerCanAccessFeature(feature) {
  const result = _.find(window.customer_plan_features, plan_feature => plan_feature.slug === feature);

  return result !== undefined && result;
}

export function permissionsIsSuperAdmin() {
  return window.user?.is_super_admin;
}

export function permissionsIsOrganisationAdmin() {
  return window.user && window.user.is_organisation_admin;
}

export function permissionsIsAdmin() {
  return window.user && window.user.is_admin;
}
